module.exports = __webpack_public_path__ + "static/media/20.ce3a772b.wav";